/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { matchPath } from "react-router"

import { AppRoutes } from "../routes/routes"

/**
 * Checks if the given pathname matches any of the defined routes in the application.
 * @param pathname - The pathname to check.
 * @returns True if the pathname matches any defined route, false otherwise.
 */
export function isValidRoute(pathname: string): boolean {
    // Special case: PageNotFound route should not be considered a valid route for this check
    const routesToCheck = Object.values(AppRoutes).filter((route) => route !== AppRoutes.PageNotFound)
    return routesToCheck.some((route) => matchPath(route, pathname) !== null)
}
